var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',[_c('div',[_c('ListWorkOrderRequestConversations',{attrs:{"workOrderRequestID":parseInt(_vm.workOrderRequestID)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }